<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="editAndAdd"
      >
        新增活动
      </a-button>
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
        <template
          slot="icon"
          slot-scope="text, record"
        >
          <img
            width="60"
            height="60"
            :src="record.icon"
            alt="图标"
          >
        </template>
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            :text="record.status===1?'禁用':'启用'"
            :alert-title="record.status===1?'确定禁用？':'确定启用？'"
            @onDelete="() => onConfirm(record)"
          />
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <account-modal
      ref="formRef"
      :btn-is-loading="btnIsLoading"
      :activity-visible="activityVisible"
      :title="title"
      :flag="flag"
      @onCancel="onCancel"
      @handleSubmit="handleSubmit"
    />
  </div>
</template>
<script>
import { columns } from './data/index';
import AccountModal from './modal/index';
export default {
  components: { AccountModal },
  data() {
    return {
      btnIsLoading: false,
      selectData: [],
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      activityVisible: false,
      title: '',
      id: '',
      flag:''

    };
  },
  mounted() {
    // 获取表格数据
    this.getTableData({
      page: String(this.current),
      pageSize: String(this.pageSize),
    });
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post(
        '/Service/getList',
        params,
      );
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        this.current = Number(params.page);
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            status: item.status,
            name: item.name,
            icon: item.icon_url,
            type: item.type,
            summary: item.summary,
            report_html: item.report_html,
            sort: item.sort,
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
      }
    },
    // 新增 编辑
    editAndAdd(record) {
      this.activityVisible=true;
      if (!record.id) {
        this.title = '新增活动';
        this.flag = '';
        this.$nextTick(() => {
          this.$refs.formRef.$refs.basicForm.form.resetFields();
        });
      } else {
        this.id=record.id;
        this.title = '编辑活动';
        this.flag = record.data.flag;
        let data={
          name: record.name,
          flag: record.data.flag,
          type: String(record.type),
          icon: [{
            uid: record.data.icon,
            name: 'img',
            url: record.icon,
            status: 'done',
          }],
          summary: record.summary,
          sort: record.sort,
          report_html: record.report_html,
        };
        console.log('data', data);
        this.$nextTick(() => {
          this.$refs.formRef.$refs.basicForm.form.setFieldsValue(data);
        });
      }
    },
    // 确认新增
    handleSubmit() {
      this.$refs.formRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          if (!err) {
            this.btnIsLoading=true;
            values.icon=values.icon[0].uid;
            values.id=this.id?this.id:undefined;
            let result = await this.$http.post(
              '/Service/update',
              values,
            );
            this.btnIsLoading=false;
            if (result.data.status === 1) {
              this.$message.success('操作成功！');
              this.activityVisible = false;
              this.getTableData({
                page: this.current,
                pageSize: this.pageSize,
              });
            }
          }
        },
      );
    },
    // 取消新增
    onCancel() {
      this.activityVisible = false;
    },
    // 禁用 启用
    async onConfirm(record) {
      let result=await this.$http.post('/Service/setStatus', {id: record.id, status: record.status===1?0:1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ page: this.current, pageSize: this.pageSize });
      }
    },
    // 删除
    async onDelete(record) {
      let result=await this.$http.post('/Service/setStatus', {id: record.id, status: -1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ page: this.current, pageSize: this.pageSize });
      }
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({
        page: String(pagination.current),
        pageSize: String(pagination.pageSize),
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
}
</style>
